"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
const react_1 = require("react");
function useOnClickOutside(ref, onOutsideClick, enabled = true) {
    (0, react_1.useEffect)(() => {
        if (!enabled)
            return;
        const onPointerDown = (event) => {
            var _a;
            if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                onOutsideClick(event);
            }
        };
        document.addEventListener("pointerdown", onPointerDown);
        return () => document.removeEventListener("pointerdown", onPointerDown);
    }, [enabled, onOutsideClick, ref]);
}
exports.useOnClickOutside = useOnClickOutside;
